<app-base-modal
  [title]="'Добавить пользователя'"
>
  <form
    class="add-user-form"
    [formGroup]="userForm"
  >
      <mat-form-field appearance="outline">
        <mat-label>Логин</mat-label>
        <input
          matInput
          required
          [formControlName]="'login'"
        >
        @if (getErrorMessage('login')) {
          <mat-error>{{ getErrorMessage('login') }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Пароль</mat-label>
        <input
          matInput
          [formControlName]="'password'"
          [type]="passwordVisible ? 'password' : 'text'"
          required
        >
        <button
          mat-icon-button
          type="button"
          matSuffix
          (click)="togglePasswordVisibility()"
        >
          <mat-icon>{{ passwordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (getErrorMessage('password')) {
          <mat-error>{{ getErrorMessage('password') }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Подтверждение пароля</mat-label>
        <input
          matInput
          [formControlName]="'confirmPassword'"
          [type]="confirmPasswordVisible ? 'password' : 'text'"
          required
          pattern="{{userForm.value.password}}"
        >
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="toggleConfirmPasswordVisibility()"
        >
          <mat-icon>{{ confirmPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (getErrorMessage('confirmPassword')) {
          <mat-error>{{ getErrorMessage('confirmPassword') }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>medium</mat-label>
        <input
          matInput
          [formControlName]="'utmMedium'"
        >
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Имя</mat-label>
        <input
          matInput
          [formControlName]="'firstName'"
        >
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Фамилия</mat-label>
        <input
          matInput
          [formControlName]="'lastName'"
        >
      </mat-form-field>
  </form>
  <div class="add-user-buttons">
    <button
      mat-button
      color="primary"
      type="button"
      [disabled]="userForm.invalid"
      (click)="addUser()"
      (keydown.enter)="addUser()"
    >
      Добавить
    </button>
  </div>
</app-base-modal>
